var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.colors,attrs:{"id":_vm.ink}},[_c('div',[_c('div',{staticClass:"big-title-box"},[_c('h1',{staticClass:"big-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"section-content",class:{ reverse: _vm.reverse }},[(!_vm.noimage)?_c('div',{staticClass:"image-box"},[_vm._t("illu")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-box"},[_vm._t("default")],2)]),_vm._v(" "),_vm._t("reminder")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40cf0cf6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/Content.vue
// module id = 142
// module chunks = 0